<h6 class='text-secondary'>
    Last Score <span class="badge badge-primary badge-pill">{{scoreSummary.lastscore}}/100</span>
    Average of Last 3 <span class="badge badge-primary badge-pill">{{scoreSummary.latestaveragethree}}/100</span>
    
    </h6>
